import type { Values } from '@ps/web-core-intl';
import type { Store } from '@ps/web-core-store';
import { useStore } from 'react-redux';

import { trackingTranslation } from '../../locales/locales';

const useTrackingLabel = (label?: Parameters<typeof trackingTranslation>['0'], values?: Values) =>
  trackingTranslation(label, useStore() as Store, values);

export default useTrackingLabel;
